export default __webpack_public_path__ + "static/media/react.326b6ca8.png";